/**
 * ヘッダーバッジに出すカートの個数を取得する。
 * ゲストの件数は localStorage 由来のため、呼び出し側で件数に変換して渡す
 * （カート情報そのものを受け取ると hydration 前の暫定値がロジックへ流れるため。GF-2387）
 * @param isLogin ログインしているかどうか
 * @param loginCartCount ログインしている場合のカートの個数
 * @param guestCartCount 未ログインの場合のカートの個数
 * @returns カートの個数
 */
export const getCartCount = (isLogin: boolean, loginCartCount: number, guestCartCount: number): number => {
  return isLogin ? loginCartCount : guestCartCount;
};
